/** Traductions communes tableaux (FR / AR) */
export const tableCommonFr = {
  loading: 'Chargement…',
  emptyTitle: 'Aucune donnée',
  emptyDescription: 'Aucune donnée ne correspond aux critères sélectionnés',
  notAvailable: 'N/D',
  searchPlaceholder: 'Rechercher…',
  statusActive: 'Actif',
  statusInactive: 'Inactif',
  statusPending: 'En attente',
  statusCompleted: 'Terminé',
  statusCancelled: 'Annulé'
};

export const tableCommonAr = {
  loading: 'جاري التحميل…',
  emptyTitle: 'لا توجد بيانات',
  emptyDescription: 'لا توجد بيانات تطابق المعايير المحددة',
  notAvailable: 'غير متوفر',
  searchPlaceholder: 'البحث…',
  statusActive: 'نشط',
  statusInactive: 'غير نشط',
  statusPending: 'في الانتظار',
  statusCompleted: 'مكتمل',
  statusCancelled: 'ملغي'
};
